(function () {
  'use strict';

  function initForm(form) {
    if (!form) return;

    var inquiryType = form.querySelector('[data-role="inquiry-type"]');
    var groupsRoot = form.querySelector('[data-role="groups-root"]');
    var commonEmail = form.querySelector('[data-role="common-email"]');
    var ecCategory = form.querySelector('[data-role="ec-category"]');
    var ecOrderWrap = form.querySelector('[data-role="ec-order-wrap"]');
    var ecOrderNumber = form.querySelector('[data-role="ec-order-number"]');
    var bulkPersonTypes = form.querySelectorAll('[data-role="bulk-person-type"]');
    var bulkCompany = form.querySelector('[data-role="bulk-company"]');
    var bulkCompanyRequired = form.querySelector('[data-role="bulk-company-required"]');
    var emailSources = form.querySelectorAll('[data-role="email-source"]');
    if (!inquiryType || !groupsRoot) return;

    var groups = {
      ec: form.querySelector('[data-group="ec"]'),
      bulk: form.querySelector('[data-group="bulk"]'),
      business: form.querySelector('[data-group="business"]'),
      other: form.querySelector('[data-group="other"]')
    };

    function resolveGroup(value) {
      if (value === 'オンラインストアについて') return 'ec';
      if (value === '大口注文について') return 'bulk';
      if (value === 'お取引のご相談について') return 'business';
      if (value === 'その他') return 'other';
      return '';
    }

    function toggleVisibleGroup(activeGroupKey) {
      var keys = Object.keys(groups);
      var hasGroup = Boolean(activeGroupKey);
      groupsRoot.hidden = !hasGroup;

      keys.forEach(function (key) {
        var group = groups[key];
        if (!group) return;
        var isActive = key === activeGroupKey;
        group.hidden = !isActive;
        group.disabled = !isActive;

        var controls = group.querySelectorAll('input, select, textarea, button');
        controls.forEach(function (control) {
          control.disabled = !isActive;
        });
      });
    }

    function switchBaseRequired(activeGroupKey) {
      Object.keys(groups).forEach(function (key) {
        var group = groups[key];
        if (!group) return;

        var shouldRequire = key === activeGroupKey;
        var fields = group.querySelectorAll('[data-required-when-visible="true"]');
        fields.forEach(function (field) {
          field.required = shouldRequire;
        });
      });
    }

    function syncCommonEmail(activeGroupKey) {
      if (!commonEmail) return;
      var value = '';
      emailSources.forEach(function (input) {
        var parentGroup = input.closest('[data-group]');
        if (!parentGroup) return;
        if (parentGroup.getAttribute('data-group') === activeGroupKey) {
          value = input.value.trim();
        }
      });
      commonEmail.value = value;
    }

    function updateEcOrderState(activeGroupKey) {
      if (!ecOrderWrap || !ecOrderNumber) return;
      var showOrder =
        activeGroupKey === 'ec' &&
        ecCategory &&
        ecCategory.value === '注文について';

      ecOrderWrap.hidden = !showOrder;
      ecOrderNumber.required = false;
      ecOrderNumber.disabled = !showOrder;
    }

    function updateBulkCompanyState(activeGroupKey) {
      if (!bulkCompany) return;
      var selected = form.querySelector('[data-role="bulk-person-type"]:checked');
      var isCorp = selected && selected.value === '法人';
      bulkCompany.required = activeGroupKey === 'bulk' && isCorp;
      if (bulkCompanyRequired) {
        bulkCompanyRequired.hidden = !isCorp;
      }
    }

    function refreshAll() {
      var activeGroupKey = resolveGroup(inquiryType.value);
      toggleVisibleGroup(activeGroupKey);
      switchBaseRequired(activeGroupKey);
      updateEcOrderState(activeGroupKey);
      updateBulkCompanyState(activeGroupKey);
      syncCommonEmail(activeGroupKey);
    }

    inquiryType.addEventListener('change', refreshAll);

    if (ecCategory) {
      ecCategory.addEventListener('change', refreshAll);
    }

    bulkPersonTypes.forEach(function (radio) {
      radio.addEventListener('change', refreshAll);
    });

    emailSources.forEach(function (input) {
      input.addEventListener('input', refreshAll);
      input.addEventListener('change', refreshAll);
    });

    form.addEventListener('submit', function () {
      refreshAll();
    });

    refreshAll();
  }

  var forms = document.querySelectorAll('[data-contact-switch-form="true"]');
  forms.forEach(function (form) {
    initForm(form);
  });
})();
